module.exports = __webpack_public_path__ + "img/conference-banner-m-0522.9f2bcc2b.png";